module.exports = __webpack_public_path__ + "1a466941c8d59a80da29860505b07c3a.png";